export default {
  metrics: {
    go_lives: 'Łączna liczba uruchomień',
    avg_quality_score: 'Średni wynik jakości',
    managers: {
      title: 'Menedżerowie onboardingu',
      fields: {
        name: 'Menedżer',
        go_lives: 'Uruchomienia',
        avg_quality_score: 'Śr. wynik jakości',
      },
    },
  },
  details: {
    name: 'Restauracja',
    owner: 'Właściciel',
    owner_phone: 'Telefon właściciela',
    owner_email: 'E-mail właściciela',
    live_from: 'Data uruchomienia',
    onboarding_manager: 'Menedżer onboardingu',
    sales_manager: 'Menedżer sprzedaży',
    onboarding_quality_score: 'Wynik jakości',
    export_csv: 'Eksportuj CSV',
  },
};
